import Service from '@ember/service';

export default class MockDataService extends Service {
  // Mock game data with realistic gaming content
  mockGames = {
    'cyberpunk-2077': {
      title: 'Cyberpunk 2077',
      slug: 'cyberpunk-2077',
      description:
        'Cyberpunk 2077 is an open-world, action-adventure story set in Night City, a megalopolis obsessed with power, glamour and body modification. You play as V, a mercenary outlaw going after a one-of-a-kind implant that is the key to immortality.',
      coverImage: {
        url: 'https://images.igdb.com/igdb/image/upload/t_cover_big/co2nv9.webp',
      },
      screenshots: {
        items: [
          {
            url: 'https://images.igdb.com/igdb/image/upload/t_screenshot_huge/sc5w8l.webp',
            description: 'Night City skyline',
          },
          {
            url: 'https://images.igdb.com/igdb/image/upload/t_screenshot_huge/sc5w8m.webp',
            description: 'Character customization',
          },
          {
            url: 'https://images.igdb.com/igdb/image/upload/t_screenshot_huge/sc5w8n.webp',
            description: 'Combat scene',
          },
        ],
      },
      genre: 'Action RPG',
      platform: [
        'PC',
        'PlayStation 5',
        'PlayStation 4',
        'Xbox Series X/S',
        'Xbox One',
      ],
      releaseDate: '2020-12-10',
      developer: 'CD Projekt RED',
      publisher: 'CD Projekt',
      rating: 7.8,
      relatedArticles: {
        items: [
          {
            __typename: 'ReviewArticle',
            title: 'Cyberpunk 2077: Phantom Liberty - A Stunning Comeback',
            shortDescription:
              'After years of updates and fixes, Cyberpunk 2077 finally delivers on its ambitious promises with the Phantom Liberty expansion.',
            slug: 'cyberpunk-2077-phantom-liberty-review',
            publishedDate: '2024-01-15',
            coverImage: {
              url: 'https://images.igdb.com/igdb/image/upload/t_cover_big/co2nv9.webp',
            },
            author: {
              displayName: 'Alex Chen',
              profilePicture: {
                url: '/img/users/01.jpg',
              },
            },
          },
          {
            __typename: 'GameArticle',
            title: 'Cyberpunk 2077 Gets Major 2.1 Update with New Features',
            shortDescription:
              'CD Projekt RED continues to improve Night City with vehicle combat, radio improvements, and quality of life updates.',
            slug: 'cyberpunk-2077-update-2-1',
            publishedDate: '2024-02-01',
            coverImage: {
              url: 'https://images.igdb.com/igdb/image/upload/t_cover_big/co2nv9.webp',
            },
            author: {
              displayName: 'Sarah Rodriguez',
              profilePicture: {
                url: '/img/users/04.jpg',
              },
            },
          },
        ],
      },
    },

    'elden-ring': {
      title: 'Elden Ring',
      slug: 'elden-ring',
      description:
        'Rise, Tarnished, and be guided by grace to brandish the power of the Elden Ring and become an Elden Lord in the Lands Between. Journey through a new fantasy world created by Hidetaka Miyazaki and George R.R. Martin.',
      coverImage: {
        url: 'https://images.igdb.com/igdb/image/upload/t_cover_big/co4jni.webp',
      },
      screenshots: {
        items: [
          {
            url: 'https://images.igdb.com/igdb/image/upload/t_screenshot_huge/sc9834.webp',
            description: 'The Lands Between landscape',
          },
          {
            url: 'https://images.igdb.com/igdb/image/upload/t_screenshot_huge/sc9835.webp',
            description: 'Boss battle against Margit',
          },
          {
            url: 'https://images.igdb.com/igdb/image/upload/t_screenshot_huge/sc9836.webp',
            description: 'Character creation screen',
          },
          {
            url: 'https://images.igdb.com/igdb/image/upload/t_screenshot_huge/sc9837.webp',
            description: 'Exploring Limgrave',
          },
        ],
      },
      genre: 'Action RPG',
      platform: [
        'PC',
        'PlayStation 5',
        'PlayStation 4',
        'Xbox Series X/S',
        'Xbox One',
      ],
      releaseDate: '2022-02-25',
      developer: 'FromSoftware',
      publisher: 'Bandai Namco Entertainment',
      rating: 9.5,
      relatedArticles: {
        items: [
          {
            __typename: 'ReviewArticle',
            title: 'Elden Ring: Shadow of the Erdtree - A Masterful Expansion',
            shortDescription:
              'FromSoftware delivers another incredible expansion that rivals the base game in scope and quality.',
            slug: 'elden-ring-shadow-erdtree-review',
            publishedDate: '2024-06-20',
            coverImage: {
              url: 'https://images.igdb.com/igdb/image/upload/t_cover_big/co4jni.webp',
            },
            author: {
              displayName: 'Marcus Thompson',
              profilePicture: {
                url: '/img/users/08.jpg',
              },
            },
          },
          {
            __typename: 'GameArticle',
            title: 'Elden Ring Celebrates 20 Million Copies Sold',
            shortDescription:
              'FromSoftware and Bandai Namco celebrate another major milestone for the critically acclaimed action RPG.',
            slug: 'elden-ring-20-million-sales',
            publishedDate: '2024-07-10',
            coverImage: {
              url: 'https://images.igdb.com/igdb/image/upload/t_cover_big/co4jni.webp',
            },
            author: {
              displayName: 'Jennifer Walsh',
              profilePicture: {
                url: '/img/users/03.jpg',
              },
            },
          },
          {
            __typename: 'ReviewArticle',
            title: 'Elden Ring Review: A Genre-Defining Masterpiece',
            shortDescription:
              'Two years later, Elden Ring still stands as one of the greatest action RPGs ever created.',
            slug: 'elden-ring-masterpiece-review',
            publishedDate: '2024-02-25',
            coverImage: {
              url: 'https://images.igdb.com/igdb/image/upload/t_cover_big/co4jni.webp',
            },
            author: {
              displayName: 'David Kim',
              profilePicture: {
                url: '/img/users/01.jpg',
              },
            },
          },
        ],
      },
    },

    'baldurs-gate-3': {
      title: "Baldur's Gate 3",
      slug: 'baldurs-gate-3',
      description:
        'Gather your party and return to the Forgotten Realms in a tale of fellowship and betrayal, sacrifice and survival, and the lure of absolute power. Mysterious abilities are awakening inside you, drawn from a mind flayer parasite planted in your brain.',
      coverImage: {
        url: 'https://images.igdb.com/igdb/image/upload/t_cover_big/co5wmk.webp',
      },
      screenshots: {
        items: [
          {
            url: 'https://images.igdb.com/igdb/image/upload/t_screenshot_huge/sc9x12.webp',
            description: 'Party dialogue scene',
          },
          {
            url: 'https://images.igdb.com/igdb/image/upload/t_screenshot_huge/sc9x13.webp',
            description: 'Turn-based combat',
          },
        ],
      },
      genre: 'CRPG',
      platform: ['PC', 'PlayStation 5', 'Xbox Series X/S', 'macOS'],
      releaseDate: '2023-08-03',
      developer: 'Larian Studios',
      publisher: 'Larian Studios',
      rating: 9.7,
      relatedArticles: {
        items: [
          {
            __typename: 'ReviewArticle',
            title: "Baldur's Gate 3: The Ultimate D&D Experience",
            shortDescription:
              'Larian Studios has created the definitive digital Dungeons & Dragons experience with incredible depth and storytelling.',
            slug: 'baldurs-gate-3-ultimate-dnd',
            publishedDate: '2023-08-15',
            coverImage: {
              url: 'https://images.igdb.com/igdb/image/upload/t_cover_big/co5wmk.webp',
            },
            author: {
              displayName: 'Emily Foster',
              profilePicture: {
                url: '/img/users/04.jpg',
              },
            },
          },
        ],
      },
    },

    'the-witcher-3': {
      title: 'The Witcher 3: Wild Hunt',
      slug: 'the-witcher-3',
      description:
        'You are Geralt of Rivia, mercenary monster slayer. Before you stands a war-torn, monster-infested continent you can explore at will. Your current contract? Tracking down Ciri — the Child of Prophecy, a living weapon that can alter the shape of the world.',
      coverImage: {
        url: 'https://images.igdb.com/igdb/image/upload/t_cover_big/co1wyy.webp',
      },
      screenshots: {
        items: [
          {
            url: 'https://images.igdb.com/igdb/image/upload/t_screenshot_huge/sc5t8z.webp',
            description: 'Geralt in Novigrad',
          },
        ],
      },
      genre: 'Action RPG',
      platform: [
        'PC',
        'PlayStation 5',
        'PlayStation 4',
        'Xbox Series X/S',
        'Xbox One',
        'Nintendo Switch',
      ],
      releaseDate: '2015-05-19',
      developer: 'CD Projekt RED',
      publisher: 'CD Projekt',
      rating: 9.8,
      relatedArticles: {
        items: [
          {
            __typename: 'GameArticle',
            title: 'The Witcher 3 Next-Gen Update Brings New Life to Classic',
            shortDescription:
              'CD Projekt RED delivers a comprehensive update that makes the classic RPG better than ever on modern consoles.',
            slug: 'witcher-3-next-gen-update',
            publishedDate: '2022-12-14',
            coverImage: {
              url: 'https://images.igdb.com/igdb/image/upload/t_cover_big/co1wyy.webp',
            },
            author: {
              displayName: 'Alex Chen',
              profilePicture: {
                url: '/img/users/01.jpg',
              },
            },
          },
        ],
      },
    },
  };

  // Method to get game by slug
  getGameBySlug(slug) {
    const game = this.mockGames[slug];
    if (!game) {
      return null;
    }

    // Transform the data to match the GraphQL response structure
    return {
      data: {
        game: {
          items: [
            {
              ...game,
              // Transform screenshots to array for template
              screenshots: game.screenshots.items.map(
                (screenshot) => screenshot.url,
              ),
              // Ensure coverImageUrl is available
              coverImageUrl: game.coverImage.url,
              // Transform relatedArticles to articles for template compatibility with proper author structure
              articles: game.relatedArticles.items.map((article) => ({
                ...article,
                coverImageUrl: article.coverImage.url,
                publishedAt: article.publishedDate,
                author: article.author
                  ? {
                      ...article.author,
                      avatarUrl: article.author.profilePicture.url,
                    }
                  : null,
              })),
            },
          ],
        },
      },
    };
  }

  // Method to get all available game slugs
  getAvailableGames() {
    return Object.keys(this.mockGames);
  }

  // Method to simulate API loading delay
  async simulateLoading(slug, delay = 1000) {
    await new Promise((resolve) => setTimeout(resolve, delay));
    return this.getGameBySlug(slug);
  }
}
